import { LinearProgress } from "@material-ui/core";
import { Field } from "formik";
import React, { memo } from "react";
import { useApiQuery } from "../../../../hooks/use-api-query";
import { Alert } from "../../../ui";
import { Checkbox, DateField, Multiselect } from "../../../ui/form_fields";
import { useQueryContext } from "../context";
import FormAccordion from "./accordion";

const AdvancedFields = ({ disabled, values, errors }) => {
  const { selectedCourts } = useQueryContext();

  const { data, isLoading } = useApiQuery(
    ["support", `advanced_form?${selectedCourts.query}`],
    {
      useQueryOptions: {
        enabled: !!selectedCourts.query,
      },
    }
  );

  const { ufs, unidades, devedores, assuntos } = data || {};

  return (
    <FormAccordion
      disabled={disabled}
      title="Busca avançada"
      headerId="advanced-header"
    >
      {isLoading ? (
        <Alert
          title="Aguarde, estamos carregando mais filtros"
          message={<LinearProgress style={{ height: "2px" }} />}
          severity="info"
        />
      ) : data ? (
        <>
          <div className="pt-10">
            <Field
              name="advanced.ufs"
              label="UF de origem"
              options={ufs}
              component={Multiselect}
              fullWidth
            />
          </div>

          <div className="pt-10">
            <Field
              name="advanced.unidades"
              label="Comarca / Subseção"
              options={unidades}
              component={Multiselect}
              isGrouped
              fullWidth
            />
          </div>

          <div className="pt-10">
            <Field
              name="advanced.devedores"
              label="Ente devedor"
              options={devedores}
              component={Multiselect}
              isGrouped
              fullWidth
            />
          </div>

          <div className="pt-10">
            <Field
              name="advanced.assuntos"
              label="Assunto"
              options={assuntos}
              component={Multiselect}
              fullWidth
            />
          </div>
        </>
      ) : null}

      <div className="w-100 pt-10">
        <Field
          className="mw-47-5"
          variant="standard"
          component={DateField}
          label="Expedido em"
          name="advanced.expedidoGteq"
          maxDate={values.expedidoLteq || new Date("2100-12-31")}
          error={!!errors?.expedidoGteq}
          helperText={errors?.expedidoGteq}
        />

        <Field
          className="mw-47-5 float-r"
          variant="standard"
          component={DateField}
          label="Expedido até"
          name="advanced.expedidoLteq"
          resetTime="end"
          minDate={values.expedidoGteq || new Date("1900-01-01")}
          error={!!errors?.expedidoLteq}
          helperText={errors?.expedidoLteq}
        />
      </div>

      <div className="pt-30">
        <div className="q-color-label">Ente federativo</div>

        {["municipal", "estadual", "federal"].map((ente) => (
          <Field
            key={ente}
            label={ente.charAt(0).toUpperCase() + ente.slice(1)}
            name={`advanced.${ente}`}
            component={Checkbox}
          />
        ))}
      </div>
    </FormAccordion>
  );
};

export default memo(AdvancedFields);
